import React from 'react';

interface VersionInfoProps {
  className?: string;
  showLabel?: boolean;
  format?: 'full' | 'compact' | 'inline';
}

const VersionInfo: React.FC<VersionInfoProps> = ({ 
  className = '',
  showLabel = false,
  format = 'inline'
}) => {
  const version = __BUILD_VERSION__;
  const buildTime = new Date(__BUILD_TIME__);
  
  // Format the build time consistently
  const formattedBuildTime = buildTime.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short'
  });

  if (format === 'full') {
    return (
      <div className={className}>
        <p className="text-xs text-gray-500">
          {showLabel && 'Version '}{version}
        </p>
        <p className="text-xs text-gray-400">
          Built {formattedBuildTime}
        </p>
      </div>
    );
  }

  if (format === 'compact') {
    return (
      <span className={className}>
        v{version} • {buildTime.toLocaleDateString()}
      </span>
    );
  }

  // inline format (default)
  return (
    <span className={className}>
      {showLabel ? 'Version ' : 'v'}{version} • {formattedBuildTime}
    </span>
  );
};

export default VersionInfo;
